import { PLACES } from './seasonalFeatured';

const RADIUS = '5mi';
export const NEIGHBOURHOOD = {
    [PLACES.ATLANTA]: [
        {
            name: 'Downtown Atlanta',
            point_radius: {
                radius: RADIUS,
                latitude: 33.7538,
                longitude: -84.3915,
            },
        },
        {
            name: 'Westside Atlanta',
            point_radius: {
                radius: RADIUS,
                latitude: 33.7865,
                longitude: -84.4454,
            },
        },
        {
            name: 'Summerhill',
            point_radius: {
                radius: RADIUS,
                latitude: 33.7457,
                longitude: -84.3755,
            },
        },
    ],
    [PLACES.CHICAGO]: [
        {
            name: 'Lincoln Park',
            point_radius: {
                radius: RADIUS,
                latitude: 41.9227,
                longitude: -87.6494,
            },
        },
        {
            name: 'Little Italy',
            point_radius: {
                radius: RADIUS,
                latitude: 41.8781,
                longitude: -87.6515,
            },
        },
        {
            name: 'River North',
            point_radius: {
                radius: RADIUS,
                latitude: 41.8876,
                longitude: -87.6366,
            },
        },
    ],
    [PLACES.WASHINGTON_DC]: [
        {
            name: 'Mount Vernon Square',
            point_radius: {
                radius: RADIUS,
                latitude: 38.9111,
                longitude: -77.0207,
            },
        },
        {
            name: 'Dupont Circle',
            point_radius: {
                radius: RADIUS,
                latitude: 38.9067,
                longitude: -77.0425,
            },
        },
        {
            name: 'Near Northeast',
            point_radius: {
                radius: RADIUS,
                latitude: 38.905,
                longitude: -77.0104,
            },
        },
    ],
    [PLACES.LONDON]: [
        {
            name: 'Wembley',
            point_radius: {
                radius: RADIUS,
                latitude: 51.5569,
                longitude: -0.2817,
            },
        },
        {
            name: 'Greenwhich',
            point_radius: {
                radius: RADIUS,
                latitude: 51.508,
                longitude: 0.0275,
            },
        },
        {
            name: 'Whitechapel',
            point_radius: {
                radius: RADIUS,
                latitude: 51.5168,
                longitude: -0.0651,
            },
        },
    ],
    [PLACES.LOS_ANGELES]: [
        {
            name: 'Hollywood',
            point_radius: {
                radius: RADIUS,
                latitude: 34.1026,
                longitude: -118.3257,
            },
        },
        {
            name: 'Downtown Los Angeles',
            point_radius: {
                radius: RADIUS,
                latitude: 34.0417,
                longitude: -118.2322,
            },
        },
        {
            name: 'South park',
            point_radius: {
                radius: RADIUS,
                latitude: 34.039,
                longitude: -118.2673,
            },
        },
    ],
    [PLACES.MELBOURNE_AU]: [
        {
            name: 'Melbourne CBD',
            point_radius: {
                radius: RADIUS,
                latitude: -37.8142,
                longitude: 144.9632,
            },
        },
        {
            name: 'Southbank',
            point_radius: {
                radius: RADIUS,
                latitude: -37.8245,
                longitude: 144.9649,
            },
        },
        {
            name: 'Carlton',
            point_radius: {
                radius: RADIUS,
                latitude: -37.7841,
                longitude: 144.9728,
            },
        },
    ],
    [PLACES.MIAMI]: [
        {
            name: 'Wynwood',
            point_radius: {
                radius: RADIUS,
                latitude: 25.8131,
                longitude: -80.1998,
            },
        },
        {
            name: 'Miami Beach',
            point_radius: {
                radius: RADIUS,
                latitude: 25.7907,
                longitude: -80.13,
            },
        },
        {
            name: 'Spring Garden',
            point_radius: {
                radius: RADIUS,
                latitude: 25.791,
                longitude: -80.2026,
            },
        },
    ],
    [PLACES.NEW_YORK]: [
        {
            name: 'Lower East Side',
            point_radius: {
                radius: RADIUS,
                latitude: 40.7151,
                longitude: -73.984,
            },
        },
        {
            name: 'Midtown West',
            point_radius: {
                radius: RADIUS,
                latitude: 40.759,
                longitude: -73.9845,
            },
        },
        {
            name: 'Chelsea',
            point_radius: {
                radius: RADIUS,
                latitude: 40.7506,
                longitude: -73.9971,
            },
        },
    ],
    [PLACES.SAN_FRANCISCO]: [
        {
            name: 'South Of Market',
            point_radius: {
                radius: RADIUS,
                latitude: 37.7725,
                longitude: -122.4102,
            },
        },
        {
            name: 'Lakeshore',
            point_radius: {
                radius: RADIUS,
                latitude: 37.7227,
                longitude: -122.4812,
            },
        },
        {
            name: 'Downtown Oakland',
            point_radius: {
                radius: RADIUS,
                latitude: 37.8049,
                longitude: -122.2711,
            },
        },
    ],
    [PLACES.TORONTO_CA]: [
        {
            name: 'Entertainment District',
            point_radius: {
                radius: RADIUS,
                latitude: 43.6404,
                longitude: -79.3912,
            },
        },
        {
            name: 'Mississauga',
            point_radius: {
                radius: RADIUS,
                latitude: 43.6879,
                longitude: -79.6114,
            },
        },
        {
            name: 'Kensington Market',
            point_radius: {
                radius: RADIUS,
                latitude: 43.6555,
                longitude: -79.4025,
            },
        },
    ],
    [PLACES.AUSTIN]: [
        {
            name: 'Downtown Austin',
            point_radius: {
                radius: RADIUS,
                latitude: 30.2672,
                longitude: -97.7431,
            },
        },
        {
            name: 'East Austin',
            point_radius: {
                radius: RADIUS,
                latitude: 30.2638,
                longitude: -97.7156,
            },
        },
        {
            name: 'South Austin',
            point_radius: {
                radius: RADIUS,
                latitude: 30.2414,
                longitude: -97.7688,
            },
        },
    ],
    [PLACES.BALTIMORE_MD]: [
        {
            name: 'Downtown Baltimore',
            point_radius: {
                radius: RADIUS,
                latitude: 39.2937,
                longitude: -76.6145,
            },
        },
        {
            name: 'Inner Harbor',
            point_radius: {
                radius: RADIUS,
                latitude: 39.2866,
                longitude: -76.6077,
            },
        },
        {
            name: 'Columbia',
            point_radius: {
                radius: RADIUS,
                latitude: 39.211,
                longitude: -76.8637,
            },
        },
    ],
    [PLACES.BOSTON_MA]: [
        {
            name: 'Brookline',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3471,
                longitude: -71.1021,
            },
        },
        {
            name: 'Back Bay',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3486,
                longitude: -71.076,
            },
        },
        {
            name: 'South Boston Waterfront',
            point_radius: {
                radius: RADIUS,
                latitude: 42.3525,
                longitude: -71.0485,
            },
        },
    ],
    [PLACES.CHARLOTTE_NC]: [
        {
            name: 'Uptown Charlotte',
            point_radius: {
                radius: RADIUS,
                latitude: 35.2271,
                longitude: -80.8431,
            },
        },
        {
            name: 'Druid Hills North',
            point_radius: {
                radius: RADIUS,
                latitude: 35.2561,
                longitude: -80.8171,
            },
        },
        {
            name: 'Westerly Hills',
            point_radius: {
                radius: RADIUS,
                latitude: 35.2406,
                longitude: -80.8682,
            },
        },
    ],
    [PLACES.DALLAS]: [
        {
            name: 'Downtown Dallas',
            point_radius: {
                radius: RADIUS,
                latitude: 32.7875,
                longitude: -96.7994,
            },
        },
        {
            name: 'South Dallas',
            point_radius: {
                radius: RADIUS,
                latitude: 32.758,
                longitude: -96.7589,
            },
        },
        {
            name: 'Deep Ellum',
            point_radius: {
                radius: RADIUS,
                latitude: 32.7885,
                longitude: -96.7768,
            },
        },
    ],
};
